<template>
  <div class="bxp-form">
    <span class="bxp-desktop-header">
      <div class="get-in-touch">
        <img
          class="env-img"
          src="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2022/06/envelope.png"
        />
        <div class="get-in-touch-heading">
          <strong> Get in <font color="#A6CE38">touch</font> </strong>
        </div>
      </div>
      <div class="schedule-a-conversatation">
        Schedule a conversation with us so we can understand your needs and
        discuss how bountiXP can help <font color="#A6CE38">you</font>.
      </div>
      <div class="divider-line"></div>
    </span>
    <span class="bxp-mobile-header">
      <h1>
        <strong>Need some help? It’s closer than you think.</strong>
      </h1>
      <p class="heading-sub-text">
        If we haven't covered your questions in the
        <a href="/bountixp-faqs">FAQs</a>, send us your details and a message of
        enquiry and we'll get back to you with an answer, pronto!
      </p>
    </span>

    <div class="thanks-column">
      <div class="thanks-text">
        Thank you for your enquiry! We’ll be in touch shortly.
      </div>
      <!-- <div class="thanks-img"> -->
      <img
        class="thanks-img"
        src="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2022/06/bXP-check-logo.png"
      />
      <!-- </div> -->

      <v-btn
        class="continue-button"
        outlined
        rounded
        color="#a6ce38"
        @click="goToHome()"
      >
        <div class="ctnbtn-text">Continue browsing</div>
      </v-btn>
    </div>

    <span class="bxp-desktop-header">
      <div class="divider-line-office"></div>
      <div class="office-header">
        <img
          class="pin-img"
          src="https://mark-cdn.bountixp.com/marketing-v2/wp-content/uploads/2022/06/map-marker-alt.png"
        />
        <div class="office-header-text">
          <strong> Office <font color="#A6CE38">locations</font> </strong>
        </div>
      </div>
      <div class="office-locations">
        <div class="loc-1-header">South Africa</div>
        <div class="loc-1-address">
          14 Stibitz St, Westlake, Cape Town, South Africa, 7945
          <br />
          <span class="loc-1-email"
            ><a href="mailto:contact@boutixp.com">
              contact@boutixp.com
            </a></span
          >
          |
          <span class="address-maps-link"
            ><a href="https://goo.gl/maps/VNjyu79THsei2uFT9" target="_blank">
              View on Google Maps
            </a></span
          >
        </div>
        <div class="loc-2-header">United Kingdom</div>
        <div class="loc-1-address">
          36-38 Westbourne Grove, Newton Road, London W2 5SH, United Kingdom
          <br />
          <span class="loc-1-email"
            ><a href="mailto:contact@boutixp.com">
              contact@boutixp.com
            </a></span
          >
          |
          <span class="address-maps-link"
            ><a href="https://goo.gl/maps/pgZ2xh4a6xXw9Cut6" target="_blank">
              View on Google Maps
            </a></span
          >
        </div>
      </div>
    </span>
  </div>
</template>



<script>
import { VueMaskDirective } from "v-mask";
import { formBus } from "@/formBus";
import TabNavigation from "../../../../custom_modules/vue-multistep-form-wizard/src/components/TabNavigation.vue";
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import MfwButton from "../../../../custom_modules/vue-multistep-form-wizard/src/components/MfwButton.vue";
export default {
  components: { TabNavigation },
  directives: {
    mask: VueMaskDirective,
  },
  data() {
    return {
      error: false,
      loadingScreen: {
        show: false,
        success: false,
      },
    };
  },
  computed: {},
  methods: {
    goToHome() {
      let url = "/";
      window.location = url;
    },
  },
};
</script>

<style>
.bxp-form {
  width: 720px !important;
  align-content: center !important;
  justify-content: center !important;
  margin: auto;
}

.get-in-touch {
  display: flex;
  flex-direction: row;
  width: 300px !important;
}
.env-img {
  height: 26px !important;
  width: 33px !important;
  margin-top: 7px;
}

.get-in-touch-heading {
  margin-left: 10px;
  height: 40px !important;
  width: 250px !important;
  /* color: #a6ce38; */
  color: #282829;
  font-family: Roboto;
  font-size: 40px;
  letter-spacing: 0;
  line-height: 40px;
  margin-bottom: 14px;
}

.schedule-a-conversatation {
  height: 48px;
  width: 700px;
  color: #282829;
  font-family: Roboto;
  font-size: 16px !important;
  letter-spacing: 0;
  line-height: 24px;
}

.divider-line {
  height: 1px;
  width: 720px;
  background-color: #f6f6f8;
  margin-top: 27px;
}

.thanks-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* justify-content: center; */
  /* margin: auto; */
}

.thanks-text {
  margin-top: 138px;
  height: 48px;
  width: 207px;
  color: #282829;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
}

.thanks-img {
  margin-top: 20px;
  height: 120x;
  width: 120px;
  color: #282829;
  font-family: Roboto;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
}

.continue-button {
  margin-top: 20px;
  margin-bottom: 138px;
  height: 38px;
  width: 170px;
  box-sizing: border-box;
  height: 38px;
  width: 170px;
  border: 2px solid #a6ce38;
  border-radius: 21px;
}

.ctnbtn-text {
  color: #69696a;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 14px;
}

.captcha-text {
  height: 20px;
  width: 445px;
  color: #282829;
  font-family: Roboto;
  font-size: 10px;
  letter-spacing: 0;
  line-height: 10px;
}

.divider-line-office {
  height: 1px;
  width: 720px;
  background-color: #f6f6f8;
  margin-top: 62px;
}

.office-header {
  display: flex;
  flex-direction: row;
  width: 357px !important;
  margin-top: 40px;
}

.pin-img {
  margin-top: 5px;
  height: 30px;
  width: 22px;
}

.office-header-text {
  margin-left: 10px;
  height: 40px;
  width: 305px;
  /* color: #A6CE38; */
  font-family: Roboto;
  font-size: 40px;
  letter-spacing: 0;
  line-height: 40px;
}

.office-locations {
  margin-top: 20px;
}

.loc-1-header {
  height: 20px;
  width: 496px;
  color: #282829;
  font-family: Roboto;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: bold;
}

.loc-1-address {
  margin-top: 10px;
  height: 40px;
  width: 600px;
  font-family: Roboto;
  font-size: 12px;
  /* font-weight: bold; */
  letter-spacing: 0;
  line-height: 20px;
}

.loc-1-email {
  height: 40px;
  width: 600px;
  color: #a6ce38;
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 20px;
}

.loc-2-header {
  height: 20px;
  width: 496px;
  color: #282829;
  font-family: Roboto;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: 40px;
  font-weight: bold;
}
</style>